var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArrowLeftDouble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.8,3c0.3,0,0.5,0.1,0.7,0.3c0.4,0.4,0.4,1,0,1.4l-7.4,7.4l7.3,7.3c0.4,0.4,0.4,1,0,1.4s-1,0.4-1.4,0l-8-8 c-0.4-0.4-0.4-1,0-1.4l8.1-8.1C19.3,3.1,19.5,3,19.8,3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.3,3c0.3,0,0.5,0.1,0.7,0.3c0.4,0.4,0.4,1,0,1.4l-7.4,7.4l7.3,7.3c0.4,0.4,0.4,1,0,1.4s-1,0.4-1.4,0l-8-8 c-0.4-0.4-0.4-1,0-1.4l8.1-8.1C11.8,3.1,12,3,12.3,3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeftDouble);
export default __webpack_public_path__ + "static/media/icon-arrow-left-double.5503f8f6f0c0ea2e642f21bbc4fdea80.svg";
export { ForwardRef as ReactComponent };